import {useTranslation} from 'react-i18next';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';

import {EmpionCollapsibleSection} from '../../../../../../components/EmpionCollapsibleSection/EmpionCollapsibleSection';
import {greenColors} from '../../../../../../layouts/theme/designSystem';
import {MatchData} from '../../../../../../types/shared-recruiting-types';

interface Props {
  match: MatchData;
}

export const MatchProfileSections = ({match}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'matchDetailsPage.matchTabs.details'});
  const talentLocationInfoText = t('talentLocationInfo');
  const talentLocationInfoLabel =
    typeof talentLocationInfoText === 'string' ? talentLocationInfoText : '';
  const desiredSalaryRaw = match.desiredSalary?.trim();
  const formattedDesiredSalary = !desiredSalaryRaw
    ? '-'
    : desiredSalaryRaw.includes('€')
      ? desiredSalaryRaw
      : `€ ${desiredSalaryRaw.replace(/^EUR\s*/i, '')}`;

  return (
    <Box sx={{mt: 2, display: 'grid', gridTemplateColumns: {xs: '1fr', md: '1fr 1fr'}, gap: 1}}>
      <Box sx={{minWidth: 0}}>
        <EmpionCollapsibleSection title={t('desiredSalary')} variant='secondary'>
          <Typography variant='body2'>{formattedDesiredSalary}</Typography>
        </EmpionCollapsibleSection>
      </Box>

      <Box sx={{minWidth: 0}}>
        <EmpionCollapsibleSection
          title={t('talentLocation')}
          variant='secondary'
          titleSuffix={
            <Tooltip title={talentLocationInfoText} placement='top' arrow>
              <IconButton
                size='small'
                aria-label={talentLocationInfoLabel}
                sx={{p: 0, color: greenColors[100], '&:hover': {backgroundColor: 'transparent'}}}
              >
                <InfoOutlinedIcon sx={{fontSize: 14}} />
              </IconButton>
            </Tooltip>
          }
        >
          <Typography variant='body2'>{match.bestAddress || '-'}</Typography>
        </EmpionCollapsibleSection>
      </Box>
    </Box>
  );
};
